import { connect } from 'react-redux'
import LogIn from '../../views/MainLayout/LogInLayout'
import { login, succeedLogin, getUser, getServerConfig } from '../../action/userAction'

function mapStateToProps(state, ownProps) {
    return {
        login: state.getIn(['data', 'login']),
        // Add loginError from the updated reducer
        loginError: state.getIn(['data', 'loginError']),
        // Keep errormsg for backward compatibility
        errormsg: state.getIn(['data', 'loginError']) || state.getIn(['data', 'errormsg']),
        access_token: state.getIn(['data', 'access_token']),
        refresh_token: state.getIn(['data', 'refresh_token']),
        // Add fetch_status to access API error information, handling various formats
        fetch_status: state.getIn(['data', 'fetch_status']) || state.getIn(['data']).get('fetch_status') || null
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toLogin: (username, password) => dispatch(login(username, password)),
        resetLogin: () => dispatch({ type: 'LOGIN_RESET' }),
        succedLogin: () => dispatch(succeedLogin()),
        getUser: () => {
            dispatch(getUser())
        },
        getServerConfig: () => {
            dispatch(getServerConfig())
        }
        // acquireLocale: () => dispatch(listLocale())
    }
}

const LogInContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LogIn)

export default LogInContainer